/**
 * SMS length thresholds.
 *
 * Historically we hard-capped SMS at 500 characters as a deliverability
 * safeguard. Per FEATURE-761 we now warn (rather than block) above that
 * threshold, and only hard-block at Twilio's actual ceiling.
 *
 * Twilio rejects any message body longer than 1600 characters (error 21617),
 * so SMS_HARD_LIMIT must stay a true block — above it the send genuinely fails.
 * Long messages are also split into multiple billed segments (153 chars each
 * for GSM-7, 67 for Unicode) and are more likely to be filtered as spam, which
 * is what the soft warning communicates.
 */

/** Above this length, warn the user but still allow sending. */
export const SMS_WARNING_THRESHOLD = 500

/** Twilio's hard maximum per message. Sends above this are rejected by Twilio. */
export const SMS_HARD_LIMIT = 1600

/**
 * Template thresholds are intentionally lower than the composer's. A template's
 * variables ({{ApplicationLink}}, {{CompanyName}}, etc.) expand to real values
 * when the message is actually sent, and those values can be longer than our
 * estimates — so we leave headroom to keep the sent message within Twilio limits.
 */
export const SMS_TEMPLATE_WARNING_THRESHOLD = 400
export const SMS_TEMPLATE_HARD_LIMIT = 1400

export const SMS_SPAM_WARNING = `Messages longer than ${SMS_WARNING_THRESHOLD} characters are more likely to be flagged as spam by carriers.`

export const SMS_HARD_LIMIT_MESSAGE = `Messages can't exceed ${SMS_HARD_LIMIT} characters.`

export const SMS_TEMPLATE_HARD_LIMIT_MESSAGE = `Templates can't exceed ${SMS_TEMPLATE_HARD_LIMIT} characters once variables are inserted.`
